/**
 * Access mode chosen on the MCP OAuth consent page.
 * REGULAR uses the user's workspace/MSP roles; GLOBAL uses their global admin role
 * (read-only plus ticket/device actions, no platform-destructive tools).
 */
export enum McpAccessMode {
  REGULAR = "REGULAR_ADMIN",
  GLOBAL = "GLOBAL_ADMIN",
}
